import React, {Component} from 'react';
import '../../App.css';
import Content from '../Content';
import Cards from '../Cards';

function Home() {
    return (
        <div>
            <Content />
            <Cards />
        </div>
    )
}

export default Home;